import React, { useState, useEffect } from 'react'
//import StatsAndStandingsHomeNavigation from '../../shared/components/Navigation/StatsAndStandingsHomeNavigation'
import PreviousTournamentsHomeNavigation from '../../shared/components/Navigation/PreviousTournamentsHomeNavigation'
import SelectLeague from '../../shared/components/UIElements/SelectLeague'
import { useHttpClient } from '../../shared/hooks/http-hook'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner'
import Footer from '../../shared/components/UIElements/Footer'
import './PreviousLeagues.css'
import { Link, NavLink } from 'react-router-dom'

const PreviousLeagues = () => {
	const { sendRequest, clearError } = useHttpClient()
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [leagueId, setLeagueId] = useState('')
	const [loadedPreviousLeagues, setLoadedPreviousLeagues] = useState()

	//Make a call to the backend to return all previous (archived) leagues.  getPreviousLeagues
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/league/previousLeagues',
				)
				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedPreviousLeagues(responseData.previousLeagues)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [])
	//
	//console.log('loadedPreviousLeagues: ' + JSON.stringify(loadedPreviousLeagues))
	//
	const errorHandler = () => {
		setError(null)
	}
	//
	//
	//
	const handleClick = (e) => {
		//e.preventDefault()
		//console.log('e: ' + e)
	}
	//
	//
	const groupedLeagues =
		loadedPreviousLeagues &&
		loadedPreviousLeagues.reduce((acc, league) => {
			if (!acc[league.year]) {
				acc[league.year] = []
			}

			acc[league.year].push(league)
			return acc
		}, {})
	//
	//
	return (
		<div style={{ overflowX: 'hidden' }}>
			<ErrorModal error={error} onClear={errorHandler} />
			<SelectLeague />
			{isLoading && (
				<div className='center'>
					<LoadingSpinner />
				</div>
			)}
			{!isLoading && !loadedPreviousLeagues && (
				<div className='Leagues'>
					<h1>No Previous Leagues Found!</h1>
				</div>
			)}
			{!isLoading && loadedPreviousLeagues && (
				<div className='PreviousLeagues'>
					<h1>Previous Tournaments</h1>
					<div className='previousLeagueTables'>
						{Object.keys(groupedLeagues)
							.sort((a, b) => b - a)
							.map((year) => (
								<table
									id='previousleagues'
									className='previousLeagueYearTable'
									key={year}
								>
									<tbody>
										<tr className='previousLeagueYearRow'>
											<td>{year}</td>
										</tr>

										{groupedLeagues[year].map((league, index) => (
											<tr
												key={league._id}
												className={
													index % 2 === 0
														? 'previousLeagueRowEven'
														: 'previousLeagueRowOdd'
												}
											>
												<td>
													<Link
														to={`/league/${league._id}`}
														style={{
															color: 'black',
															fontWeight: 600,
															textDecoration: 'none',
														}}
													>
														{league.leagueName}
														{league.divisionName &&
															' - ' + league.divisionName + ' Division'}
													</Link>
												</td>
											</tr>
										))}
									</tbody>
								</table>
							))}
					</div>
					{/* <table id='previousleagues'>
						<thead>
							<tr>
								<th>Tournament</th>
							</tr>
						</thead>
						<tbody>
							{loadedPreviousLeagues.map((league, key) => {
								return (
									<tr key={key}>
										<td>
											<Link
												to={`/league/${league._id}`}
												style={{
													color: 'black',
													fontWeight: 600,
													textDecoration: 'none',
												}}
											>
												{league.year} {league.leagueName}{' '}
												{league.divisionName &&
													' - ' + league.divisionName + ' Division'}
											</Link>
										</td>
									</tr>
								)
							})}
						</tbody>
					</table> */}
				</div>
			)}
			{/* <StatsAndStandingsHomeNavigation leagueId={leagueId} /> */}
			<PreviousTournamentsHomeNavigation leagueId={leagueId} />
			<Footer />
		</div>
	)
}

export default PreviousLeagues
